import { Box, Button, Grid, Dialog, DialogTitle, DialogContent, IconButton, Typography } from "@mui/material";
import { Close as CloseIcon } from '@mui/icons-material';
import React, { useState } from "react";
import WSTextField from "../../Components/TextBox/WSTextBox";
import { useForm } from "react-hook-form";

interface SeatNoProps {
  open: boolean;
  onClose: () => void;
}

export const SeatNumberModal: React.FC<SeatNoProps> = ({ open, onClose }) => {
  // Initialize the form with a default value for seatno
  const { register, control, setValue, getValues } = useForm({
    defaultValues: { seatno: "0" }, // Setting initial value to 0
  });

  const handleButtonClick = (value: string) => {
    const currentSeatNumber = getValues("seatno") || ""; // Get current value from form
    const updatedSeatNumber = currentSeatNumber === "0" ? value : currentSeatNumber + value; // Replace initial 0 if needed
    setValue("seatno", updatedSeatNumber); // Update the seat number in the form
  };

  const handleBackspace = () => {
    const currentSeatNumber = getValues("seatno") || "";
    const updatedSeatNumber = currentSeatNumber.length === 1 ? "0" : currentSeatNumber.slice(0, -1); // Handle backspace to reset to 0 if empty
    setValue("seatno", updatedSeatNumber); // Update the seat number in the form
  };

  const handleClear = () => {
    setValue("seatno", "0"); // Clear and set to 0
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle
        sx={{ backgroundColor: "green", color: "white", display: "flex", justifyContent: "space-between", alignItems: "center" }}
      >
        <Typography>Enter Seat No</Typography>
        <IconButton onClick={onClose} sx={{ color: "white" }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ mt: 2 }}>
        {/* Seat Number TextField */}
        <WSTextField
          label={""}
          {...register("seatno")}
          id="seatno"
          name="seatno"
          control={control}
          rules={{ required: false }}
        />

        {/* Keypad */}
        <Grid container spacing={1} sx={{ mt: 2 }}>
          {[1, 2, 3].map((num) => (
            <Grid item xs={4} key={num}>
              <Button fullWidth variant="outlined" onClick={() => handleButtonClick(num.toString())}>
                {num}
              </Button>
            </Grid>
          ))}
          {[4, 5, 6].map((num) => (
            <Grid item xs={4} key={num}>
              <Button fullWidth variant="outlined" onClick={() => handleButtonClick(num.toString())}>
                {num}
              </Button>
            </Grid>
          ))}
          {[7, 8, 9].map((num) => (
            <Grid item xs={4} key={num}>
              <Button fullWidth variant="outlined" onClick={() => handleButtonClick(num.toString())}>
                {num}
              </Button>
            </Grid>
          ))}
          <Grid item xs={4}>
            <Button fullWidth variant="outlined" onClick={handleBackspace}>
              {"<"}
            </Button>
          </Grid>
          <Grid item xs={4}>
            <Button fullWidth variant="outlined" onClick={() => handleButtonClick("0")}>
              0
            </Button>
          </Grid>
          <Grid item xs={4}>
            <Button fullWidth variant="outlined" onClick={handleClear}>
              C
            </Button>
          </Grid>
        </Grid>
      </DialogContent>
      <Grid item mt={2} sx={{ backgroundColor: "#333", display: "flex", justifyContent: "flex-end", padding: 2 }}>
        <Button variant="contained" color="success" onClick={onClose}>
          Finish
        </Button>
      </Grid>
    </Dialog>
  );
};
